export const ApiUrls = {
    StaticPlayableApiUrl :" https://imedia-api.growatiopex.com/playablehub/create",
    imediaroot:"https://imedia-api.growatiopex.com"
}